var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.className,attrs:{"disabled":_vm.disabled || _vm.loading}},[(!_vm.loading)?_vm._t("default"):_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Cargando...")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }